import global from "@/locales/et-EE/global";
import error403 from "@/locales/et-EE/errors/403";
import error404 from "@/locales/et-EE/errors/404";
import error500 from "@/locales/et-EE/errors/500";
import error503 from "@/locales/et-EE/errors/503";
import error504 from "@/locales/et-EE/errors/504";
import maintenance from "@/locales/et-EE/auth/maintenance";
import toast from "@/locales/et-EE/toast/toast";
import login from "@/locales/et-EE/auth/login";
import onboarding from "@/locales/et-EE/auth/onboarding";
import loginPageSteps from "@/locales/et-EE/loginPageSteps";
import dashboard from "@/locales/et-EE/dashboard/dashboard";
import account from "@/locales/et-EE/account/account";
import mailbox from "@/locales/et-EE/account/mailbox";
import bankstatement from "@/locales/et-EE/account/bankstatement";
import myApps from "@/locales/et-EE/my-apps/myApps";
import about from "@/locales/et-EE/about/about";
import contactService from "@/locales/et-EE/about/contactService";
import salesPromotions from "@/locales/et-EE/sales/promotions";
import brochures from "@/locales/et-EE/sales/brochures";
import shop from "@/locales/et-EE/shop/data";
import priceList from "@/locales/et-EE/shop/priceList";
import staff from "@/locales/et-EE/dashboard/staff";
import promotions from "@/locales/et-EE/promotions";
import points from "@/locales/et-EE/points";
import trainings from "@/locales/et-EE/trainings/trainings";
import vouchers from "@/locales/et-EE/vouchers/vouchers";
import media from "@/locales/et-EE/media/index";
import product from "@/locales/et-EE/product/index";
import message from "@/locales/et-EE/message/index";
import commitmentLetter from "@/locales/et-EE/account/commitmentLetter";
import multiplicator from "@/locales/et-EE/multiplicator";
import widgets from "@/locales/et-EE/widgets/widgets";
import consents from "@/locales/et-EE/consents/consents";
import investment from "@/locales/et-EE/investment/data";
import kickback from "@/locales/et-EE/kickback";
//prettier-ignore
const messages = {
  loginPageSteps: loginPageSteps.messages,
  global: global.messages,
  error403: error403.messages,
  error404: error404.messages,
  error500: error500.messages,
  error503: error503.messages,
  error504: error504.messages,
  maintenance: maintenance.messages,
  toast: toast.messages,
  login: login.messages,
  onboarding: onboarding.messages,
  dashboard: dashboard.messages,
  multiplicator: multiplicator.messages,
  account: account.messages,
  mailbox: mailbox.messages,
  myApps: myApps.messages,
  bankstatement: bankstatement.messages,
  about: about.messages,
  contactService: contactService.messages,
  salesPromotions: salesPromotions.messages,
  shop: shop.messages,
  staff: staff.messages,
  promotions: promotions.messages,
  points: points.messages,
  brochures: brochures.messages,
  trainings: trainings.messages,
  vouchers: vouchers.messages,
  media: media.messages,
  priceList: priceList.messages,
  productInfo: product.messages,
  message: message.messages,
  commitmentLetter: commitmentLetter.messages,
  widgets: widgets.messages,
  consents: consents.messages,
  investment: investment.messages,
  kickback: kickback.messages,
  productBrochures: {
    BDriveTitle: "Toodete pildid",
    BDriveLinkText: "Link TOODETE PILTIDE portaali",
  },
}

export default {
  locale: "et-EE",
  messages,
};
